;(() => {
  const wishlistButtons = document.querySelectorAll('button.btn-wishlist')
  updateWishlistCounts()

  function getWishlist() {
    const storage = localStorage.getItem('wishlist')
    return storage ? JSON.parse(storage) : []
  }

  function updateWishlistCounts() {
    const wishlistCounts = document.querySelectorAll('.wishlist-count')
    const wishlistLength = getWishlist().length
    wishlistCounts.forEach((item) => {
      item.textContent = wishlistLength
      item.hidden = wishlistLength === 0
    })
  }

  function addProductToWishlist(productHandle) {
    const wishlistProducts = getWishlist()
    const newSet = new Set([...wishlistProducts])
    newSet.add(productHandle)
    localStorage.setItem('wishlist', JSON.stringify([...newSet]))

    const item = {
      product_handle: productHandle
    }

    klaviyo.push(['track', 'Added to Wishlist', item])
  }

  function removeProductFromWishlist(productHandle) {
    const wishlistProducts = getWishlist()
    const updatedWishlist = wishlistProducts.filter(
      (item) => item !== productHandle
    )
    localStorage.setItem('wishlist', JSON.stringify(updatedWishlist))
  }

  function handleWishlistButtonClick(event) {
    event.preventDefault()
    const productUrl = this.getAttribute('data-product-url')
    const productHandle = productUrl.match(/\/products\/([^?]+)/)[1]

    if (!this.classList.contains('active')) {
      addProductToWishlist(productHandle)
      this.classList.add('active')
      document
        .querySelectorAll(`.btn-wishlist[data-product-url="${productUrl}"]`)
        .forEach((button) => button.classList.add('active'))
      showToastNotifcation()
    } else {
      removeProductFromWishlist(productHandle)
      this.classList.remove('active')

      //edge case where a product is removed from the wishlist from the quick view modal, we need to remove the active state from the product card already on the page
      document
        .querySelectorAll(`.btn-wishlist[data-product-url="${productUrl}"]`)
        .forEach((button) => {
          button.classList.remove('active')
        })

      if (document.querySelector('html.template-page-wishlist')) {
        const productCard = this.closest('#shopify-section-product-card')
        if (productCard) {
          productCard.animate(
            { opacity: [1, 0] },
            { duration: 200, fill: 'forwards' }
          ).onfinish = () => {
            productCard.remove()
          }
        }
      }
    }

    updateWishlistCounts()
  }

  function wishlistAddActiveState(button) {
    const wishListItems = getWishlist()
    const productUrl = button.getAttribute('data-product-url')
    const productHandle = productUrl.match(/\/products\/([^?]+)/)[1]
    if (wishListItems.includes(productHandle)) {
      button.classList.add('active')
    }
  }

  wishlistButtons.forEach((button) => {
    button.addEventListener('click', handleWishlistButtonClick)
    wishlistAddActiveState(button)
  })

  const wishlistObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          node.matches('.btn-wishlist')
        ) {
          node.addEventListener('click', handleWishlistButtonClick)
          wishlistAddActiveState(node)
        }
        //also check child nodes
        node.querySelectorAll?.('.btn-wishlist').forEach((child) => {
          child.addEventListener('click', handleWishlistButtonClick)
          wishlistAddActiveState(child)
        })
      })
    })
  })

  wishlistObserver.observe(document.body, { childList: true, subtree: true })

  let toastAnimation
  const toastNotification = document.querySelector('#toast-notification')
  function showToastNotifcation() {
    if (toastAnimation) {
      toastAnimation.cancel()
    }

    if (toastNotification) {
      toastAnimation = toastNotification.animate(
        [
          { opacity: 0, transform: 'translateX(100%)' },
          { opacity: 1, transform: 'translateX(0)' }
        ],
        { duration: 200, fill: 'forwards' }
      ).onfinish = () => {
        toastAnimation = toastNotification.animate(
          { opacity: [1, 0] },
          { duration: 200, delay: 2000, fill: 'forwards' }
        )
      }
    }
  }
})()
